<template>
    <div class="d-flex align-items-center">
        <div 
            :class="[this.size, this.marginRight]" v-if="this.firstName || this.lastName" 
            :style="avatarStyle" >
            {{ showInitials ? dropCap : '' }}
        </div> <div class="np-profile-list__item-text" v-if="!short">{{ shortName }}</div>
    </div>
</template>

<script>
    import { nameColor } from '@/utils/format'
    import Config from '@/config'

    export default {
        props: {
            firstName: {
                type: String,
                default: ''
            },
            lastName: {
                type: String,
                default: ''
            },
            avatar: {
                type: String,
                default: ''
            },
            size: {
                type: String,
                default: 'np-avatar-small'
            },
            marginRight: {
                type: String,
                default: 'me-1'
            },
            short: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return { 
                Config
            }
        },
        computed: {
            shortName() {
                return this.firstName && this.lastName ? this.firstName + " " + this.lastName : '';
            },
            dropCap() {
                return (this.firstName ? this.firstName[0] : '') + (this.lastName ? this.lastName[0] : '')
            },
            showInitials() {
                return !this.avatar
            },
            avatarStyle() {
                if (this.avatar) {
                    const fullPhotoPath = (this.avatar.indexOf('http://') === 0 || this.avatar.indexOf('https://') === 0) ? this.avatar : Config.SERVER + 'web/' + this.avatar
                    return {
                        'background-image': `url(${fullPhotoPath})`,
                        'background-size': 'cover',
                        'background-position': 'center',
                        'background-repeat': 'no-repeat'
                    }
                } else {
                    return {
                        'background-color': this.nameColor(this.firstName)
                    }
                }
            }            
        },
        methods: {
            nameColor
        }
    }
</script>